import { useRef } from 'react';
import { SectionIntro } from '@/landing/components';
import { Card, CardHeader, CardContent, Button } from 'dreambel-ui';
import { downloadFramerie } from '@/utils/download';
import { scrollToSection } from '@/utils/scroll';
import { useTranslation } from '@/i18n/hooks/useTranslation';

export function Closing() {
  const closingRef = useRef<HTMLElement>(null);
  const { t } = useTranslation();

  const catchTitle = (
    <>
      {t('closing.title.part1')}
      <i>{t('closing.title.frame')}</i>
      <br />
      {t('closing.title.part2')}
      <b>{t('closing.title.framerie')}</b>
    </>
  );

  return (
    <section id="closing" ref={closingRef} className="section closing">
      <Card
        elevation="none"
        variant="outlined"
        className="p-2 flex-1 w-full sm:w-[75%]"
      >
        <CardHeader>
          <SectionIntro title={catchTitle} subtitle={t('closing.subtitle')} />
        </CardHeader>
        <CardContent className="flex justify-center w-full">
          <div className="flex flex-col sm:flex-row gap-4 mt-8 w-full sm:w-[75%] h-[8rem] sm:h-auto">
            <Button
              className="h-[5rem] flex-1 flex justify-center text-xl text-md-on-primary hover:border-md-outline"
              variant="outlined"
              onClick={downloadFramerie}
            >
              <svg
                className="size-7 text-gray-12 opacity-90"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 256 256"
              >
                <path d="M112 144v51.64a8 8 0 0 1-8 8 8.5 8.5 0 0 1-1.43-.13l-64-11.64A8 8 0 0 1 32 184v-40a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8m-2.87-89.78a8 8 0 0 0-6.56-1.73l-64 11.64A8 8 0 0 0 32 72v40a8 8 0 0 0 8 8h64a8 8 0 0 0 8-8V60.36a8 8 0 0 0-2.87-6.14M216 136h-80a8 8 0 0 0-8 8v57.45a8 8 0 0 0 6.57 7.88l80 14.54a7.6 7.6 0 0 0 1.43.13 8 8 0 0 0 8-8v-72a8 8 0 0 0-8-8m5.13-102.14a8 8 0 0 0-6.56-1.73l-80 14.55a8 8 0 0 0-6.57 7.87V112a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8V40a8 8 0 0 0-2.87-6.14"></path>
              </svg>
              {t('common.actions.downloadForFree')}
            </Button>
            <Button
              className="h-[5rem] flex-1 flex justify-center text-xl"
              variant="filled"
              onClick={() => scrollToSection('pricing')}
            >
              {t('common.actions.updatePremium')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
